export const EHelloAction = {
  GET_HELLO_REQUEST: "GET_HELLO_REQUEST",
  GET_HELLO_SUCCESS: "GET_HELLO_SUCCESS",
  GET_HELLO_FAILED: "GET_HELLO_FAILED",

  SHOW: "SHOW",
};
